import React from 'react';
import { FeatureFlagOffProps } from './types';

export default class FeatureFlagOff extends React.Component<FeatureFlagOffProps> {
  render() {
    return this.props.children || null;
  }
}
